module.exports = __webpack_public_path__ + "img/etalon.06d6697f.svg";